/* 704 EXOTICS — Product card hover swap to image #2 (v3, incl. coll-feat) */
(function () {
  'use strict';
  const CACHE = new Map();
  const CARD_SELECTOR = '.card-wrapper, .product-card-wrapper, .card--product, .coll-feat__card';
  const MEDIA_SELECTOR = '.card__media, .media, .product-media-container, .card__inner, .coll-feat__media';

  function handleFromHref(href) {
    try {
      const url = new URL(href, window.location.origin);
      const parts = url.pathname.split('/');
      const i = parts.indexOf('products');
      return i === -1 ? null : parts[i + 1] || null;
    } catch (_) { return null; }
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (CACHE.has(handle)) return CACHE.get(handle);
    try {
      const res = await fetch('/products/' + handle + '.js', { credentials: 'same-origin' });
      if (!res.ok) throw 0;
      const p = await res.json();
      CACHE.set(handle, p);
      return p;
    } catch (_) { CACHE.set(handle, null); return null; }
  }

  function normalize(src) {
    if (!src) return null;
    if (src.startsWith('//')) return 'https:' + src;
    return src;
  }

  async function upgradeCard(card) {
    if (card.dataset.hoverSwapDone) return;
    card.dataset.hoverSwapDone = '1';

    let link = card.matches('a') ? card : card.querySelector('a[href*="/products/"]');
    const container = card.querySelector(MEDIA_SELECTOR);
    if (!link || !container) return;
    if (container.querySelector('[data-hover-swap]')) return;

    const handle = handleFromHref(link.getAttribute('href'));
    const product = await fetchProduct(handle);
    if (!product) return;
    const images = (product.images || []).map(normalize).filter(Boolean);
    if (images.length < 2) return;

    const cs = window.getComputedStyle(container);
    if (cs.position === 'static') container.style.position = 'relative';

    const img = document.createElement('img');
    img.src = images[1];
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.setAttribute('data-hover-swap', '1');
    img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:0;transition:opacity 300ms ease;pointer-events:none;z-index:3;';
    container.appendChild(img);
  }

  function init() {
    const cards = document.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) { cards.forEach(upgradeCard); return; }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { upgradeCard(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '400px 0px', threshold: 0.01 });
    cards.forEach(function (c) { io.observe(c); });
  }

  function bindHover() {
    document.addEventListener('mouseover', function (e) {
      const card = e.target.closest(CARD_SELECTOR);
      if (!card) return;
      const swap = card.querySelector('[data-hover-swap]');
      if (swap) swap.style.opacity = '1';
    }, true);
    document.addEventListener('mouseout', function (e) {
      const card = e.target.closest(CARD_SELECTOR);
      if (!card) return;
      const to = e.relatedTarget;
      if (to && card.contains(to)) return;
      const swap = card.querySelector('[data-hover-swap]');
      if (swap) swap.style.opacity = '0';
    }, true);
  }

  function start() { init(); bindHover(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
  document.addEventListener('shopify:section:load', init);
})();
